module.exports = __webpack_public_path__ + "img/组 362 拷贝.92049564.png";